/* lua.js generated code 0.3.0 */

QQShareUtil = {}
QQShareUtil.shareInviteUrlWithTitle = function (onSuccess, onFail, onCancel, shareSubType, shareLink, title, textId, bg) {
    var callback = table(
        [1, "onSuccess", onSuccess],
        [1, "onError", onFail],
        [1, "onCancel", onCancel],
        [1, "onWxCallback", onWxCallback]
    )
    var shareScene = shareSubType
    if (shareSubType == null) {
        shareScene = QQShareType.toQQ
    }
    // title, text, thumb, url, callback, shareScene
    GameProxy.getInstance().shareLink(textId, title, null, null, shareLink, callback, shareScene, bg)
}

QQShareUtil.shareWechatgameNewUserGiftUrl = function (onSuccess, onFail, onCancel) {
    let shareLink = GameProxy.getInstance().getShareLink("Feed_wechatgame_newUserGiftbag")
    QQShareUtil.shareInviteUrlWithTitle(onSuccess, onFail, onCancel, QQShareType.toQQ, shareLink, null, null, null, onWxCallback)
}
QQShareUtil.shareWechatgameEnergy = function (onSuccess, onFail, onCancel, onWxCallback) {
    // let shareLink = GameProxy.getInstance().getShareLink("Feed_wechatgame_energeCharge")
    let shareLink = GameProxy.getInstance().getShareLinkStr({srcapp: "Feed_wechatgame_energeCharge", chestId: UserManager.getInstance().uid})
    QQShareUtil.shareInviteUrlWithTitle(onSuccess, onFail, onCancel, QQShareType.toQQ, shareLink, null, null, null, onWxCallback)
}
